import React from "react";

import { QFormControl, QSelect } from "@qualio/ui-components";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

export const Status: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Controller
      name="status"
      render={({ field: { onChange, value } }) => (
        <QFormControl label={t("filters.status")}>
          <QSelect
            value={value}
            onChange={(selectedItem) =>
              selectedItem && onChange(selectedItem.value)
            }
            options={[
              {
                value: "IN_PROGRESS",
                label: t("statuses.review.draft"),
              },
              {
                value: "SENT_FOR_APPROVAL",
                label: t("statuses.review.forApproval"),
              },
              {
                value: "APPROVED",
                label: t("statuses.review.approved"),
              },
              {
                value: "NOT_APPROVED",
                label: t("statuses.review.declined"),
              },
            ]}
          />
        </QFormControl>
      )}
    />
  );
};
